module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraBold.628a261.ttf";